/**
 * Interface for profile mentions
 * Not complete, but enough for our use case
 * Do enrich if need be, or move this out to a separate file with post models
 */
interface ProfileMention {
  type: string;
  profile: {
    displayName: string;
  };
}

/**
 * Interface for hashtag mentions
 * Not complete, but enough for our use case
 * Do enrich if need be, or move this out to a separate file with post models
 */
interface HashtagMention {
  type: string;
  target: string;
}

/**
 * Extracts the profile mention string from the mentions
 * Mention list contains all mention types, so we filter the profile mentions
 * @param mentions - The mentions to extract the profile mention string from
 * @returns The profile mention string
 */
export const getProfileMentionString = (mentions: [ProfileMention]) => {
  const profileMentions = mentions?.filter((m) => m.type === '@') ?? [];
  if (!profileMentions.length) {
    return '';
  }
  return (
    `'` +
    profileMentions
      .map((m) => m.profile.displayName)
      .filter(Boolean)
      .join(`', '`) +
    `'`
  );
};

/**
 * Extracts the hashtag string from the mentions
 * Hashtag list contains only hastags, so no need to filter
 * Beware that this won't work if used with the mentions list that contains other mention types (although that list also contains hastags)
 * @param mentions - The mentions to extract the hashtag string from
 * @returns The hashtag string
 */
export const getHashtagString = (mentions: [HashtagMention]) => {
  return mentions?.length
    ? `'` +
        mentions
          .map((h) => h.target)
          .filter(Boolean)
          .join(`', '`) +
        `'`
    : '';
};
